import { useTranslation } from 'react-i18next';
import RuleConditionIfAnswer from '../RuleConditionIfAnswer';
import RuleConditionShowIf from '../RuleConditionShowIf';
import { useQuestionEditorContext } from 'components/Questionsv2/builder/context/create-question.context';
import { removeConditionAt } from 'components/Rules/helpers/ruleUpdates';
import RuleConditionFields from 'components/Rules/RuleCondition';
import { upsertQuestionRule } from 'rtk/Question.Editor.Slice';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { selectQuestionIsReadonly } from 'rtk/questionEditorSelector';
import { ERuleType } from 'types/rules.types';
import type { TQuestionRule, TQuestionRuleCondition } from 'types/rules.types';

interface Props {
  rule: TQuestionRule;
  condition: TQuestionRuleCondition;
  conditionIdx: number;
}

const RuleCondition = ({ rule, condition, conditionIdx }: Props) => {
  const { t } = useTranslation('Templates');
  const { questionId } = useQuestionEditorContext();
  const dispatch = useAppDispatch();
  const isReadOnly = useAppSelector((state) => selectQuestionIsReadonly(state, questionId));

  return (
    <RuleConditionFields
      index={conditionIdx}
      isReadOnly={isReadOnly}
      canRemove={rule.conditions.length > 1}
      onRemove={() => dispatch(upsertQuestionRule({ questionId, rule: removeConditionAt(rule, conditionIdx) }))}
    >
      {rule.type === ERuleType.SHOW_IF ? (
        <RuleConditionShowIf rule={rule} condition={condition} conditionIdx={conditionIdx} />
      ) : rule.type === ERuleType.DO_IF ? (
        <RuleConditionIfAnswer rule={rule} condition={condition} conditionIdx={conditionIdx} />
      ) : (
        <div>{t('question.ruleConditions.ruleTypeError')}</div>
      )}
    </RuleConditionFields>
  );
};

export default RuleCondition;
